<template>
  <div class="wrapper">
    <ai-header />
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import aiHeader from "./components/ai-header.vue";
export default {
  name: "Main",
  components: {
    aiHeader,
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  overflow-y: hidden;
  .wrapper__option {
    box-sizing: border-box;
    margin: 100px auto 0;
    border: 1px solid transparent;
    text-align: center;
  }
}
.fade-enter-active,
.fade-leave-avtive {
  transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
